// extracted by mini-css-extract-plugin
export default {"legacyColor-greyText":"#929394","lightestGrey":"undefined","titleDetail":"TitleDetail__titleDetail___kCcLY fonts__whitney-book___cSNvy","seperator":"TitleDetail__seperator___MQHpv"};